import { useFragment, graphql } from "react-relay";

import { widgetSettingsAvailable_widget$key } from "./__generated__/widgetSettingsAvailable_widget.graphql";

export const useIsWidgetSettingsAvailable = (
  widgetKey: widgetSettingsAvailable_widget$key
) => {
  const widget = useFragment(
    graphql`
      fragment widgetSettingsAvailable_widget on Widget {
        id
        __typename
        ... on WidgetNote {
          editingMode
        }
      }
    `,
    widgetKey
  );
  switch (widget.__typename) {
    case "WidgetNote":
      return widget.editingMode !== "READ_ONLY";
    case "WidgetTaskCollection":
    case "WidgetFile":
    case "WidgetTodoOverview":
    case "WidgetSignalOverview":
    case "WidgetRoutineOverview":
    case "WidgetIssueOverview":
    case "WidgetTaskSingle":
    case "WidgetEmployeeSchedule":
    case "WidgetEmployeeLeave":
    case "WidgetIssueSummary":
    case "WidgetTodoSummary":
    case "WidgetCalendarOverview":
    case "WidgetEmployeeRoleOverview":
      return true;
    default:
      return false;
  }
};
//case "WidgetTodoSummary":
